/*
 * @Author:
 * @LastEditTime: 2023-04-13 18:00:48
 * @Description:
 */
import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from '@/services/instance'

export default class StdBusinessOperation {
  static async getOpenType() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/StdBusinessOperation/get_open_type')
    )
    return Callback(err, res)
  }
  static async getOperationCategory() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/StdBusinessOperation/get_operation_category')
    )
    return Callback(err, res)
  }
  static async save(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdBusinessOperation', payload))
    return Callback(err, res)
  }
  static async update(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdBusinessOperation', payload))
    return Callback(err, res)
  }
  static async find(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdBusinessOperation?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async remove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/StdBusinessOperation', payload)
    )
    return Callback(err, res)
  }
}
